<div class="p-6">

  <!-- Breadcrumb -->
  <nav class="flex items-center gap-2 text-sm text-gray-500 mb-5">
    <a routerLink="/automation/workflows" class="hover:text-blue-600 transition-colors">Workflows</a>
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
    </svg>
    <a routerLink="/automation/workflows"
       class="hover:text-blue-600 transition-colors">{{ workflow?.name ?? 'Workflow' }}</a>
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
    </svg>
    <span class="text-gray-900 dark:text-white font-medium">Inscripciones</span>
  </nav>

  <!-- Header -->
  <div class="flex items-center justify-between mb-5">
    <div>
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Inscripciones</h1>
      @if (workflow) {
        <div class="flex items-center gap-2 mt-1">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ workflow.name }}</span>
          <span class="text-xs px-1.5 py-0.5 rounded-full font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-700': workflow.status === 'ACTIVE',
                  'bg-yellow-100 text-yellow-700': workflow.status === 'PAUSED',
                  'bg-gray-100 text-gray-600': workflow.status === 'DRAFT',
                  'bg-red-100 text-red-700': workflow.status === 'ARCHIVED'
                }">
            {{ workflowStatusText(workflow.status) }}
          </span>
        </div>
      }
    </div>
    <div class="flex gap-2">
      <a [routerLink]="['/automation/workflows', workflowId, 'monitoring']"
         class="inline-flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
        </svg>
        Monitoreo
      </a>
      <button (click)="loadEnrollments()"
              class="inline-flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Actualizar
      </button>
      <button (click)="openEnrollModal()"
              class="inline-flex items-center gap-1.5 px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
        </svg>
        Inscribir manualmente
      </button>
    </div>
  </div>

  <!-- El éxito va por ToastService (INC_CRM_020 (2) inc11); el error queda fijo abajo. -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''">&times;</button>
    </div>
  }

  <!-- Filtros -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 mb-4">
    <div class="flex flex-wrap gap-3">
      <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (opt of statusOptions; track opt.value) {
          <option [value]="opt.value">{{ opt.label }}</option>
        }
      </select>
      <select [(ngModel)]="filterObjectType" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        <option value="">Todos los tipos</option>
        @for (opt of objectTypeOptions; track opt.value) {
          <option [value]="opt.value">{{ opt.label }}</option>
        }
      </select>
      <input type="number" [(ngModel)]="filterObjectId" (ngModelChange)="onFilterChange()"
             placeholder="ID de objeto"
             class="w-32 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
      @if (filterStatus || filterObjectType || filterObjectId !== '') {
        <button (click)="filterStatus = ''; filterObjectType = ''; filterObjectId = ''; onFilterChange()"
                class="px-3 py-2 text-sm text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          Limpiar
        </button>
      }
      <label class="flex items-center gap-2 cursor-pointer ml-auto">
        <input type="checkbox" [(ngModel)]="hideTestRuns"
               class="w-4 h-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500"/>
        <span class="text-sm text-gray-600 dark:text-gray-400">Ocultar pruebas</span>
      </label>
    </div>
  </div>

  <!-- Tabla -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
    @if (loading) {
      <div class="flex justify-center py-12 text-gray-400">
        <svg class="animate-spin w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando inscripciones...
      </div>
    } @else if (filteredEnrollments.length === 0) {
      <div class="flex flex-col items-center justify-center py-14 text-gray-400">
        <svg class="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
        <p class="text-base font-medium text-gray-500 dark:text-gray-400">Sin inscripciones</p>
        <p class="text-sm text-gray-400 mt-1">Activa el workflow y envía un evento o inscribe manualmente.</p>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">ID</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Objeto</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">ID del registro</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Estado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Nodo actual</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Inscrito por</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Inscrito el</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Completado / Salida</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Error</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (e of filteredEnrollments; track e.id) {
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                <td class="px-4 py-3 font-mono text-xs text-gray-500">
                  #{{ e.id }}
                  @if (isTestRunEnrollment(e)) {
                    <span class="ml-1 px-1 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">Prueba</span>
                  }
                </td>
                <td class="px-4 py-3 font-medium text-gray-900 dark:text-white" [title]="e.objectType">
                  {{ e.objectName || objectTypeText(e.objectType) }}
                </td>
                <td class="px-4 py-3 text-gray-600 dark:text-gray-400 font-mono text-xs">{{ e.objectId }}</td>
                <td class="px-4 py-3">
                  <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="getStatusClass(e.status)">
                    {{ getStatusLabel(e.status) }}
                  </span>
                  @if ((e.status === 'EXITED' || e.status === 'CANCELLED') && e.exitReason) {
                    <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5 max-w-[160px] truncate"
                       [title]="e.exitMessage || e.exitReason">
                      {{ exitReasonText(e.exitReason) }}
                    </p>
                  }
                </td>
                <td class="px-4 py-3 text-gray-500 dark:text-gray-400 text-xs" [title]="e.currentNodeId ? ('nodo #' + e.currentNodeId) : ''">
                  {{ nodeText(e.currentNodeId) }}
                </td>
                <td class="px-4 py-3">
                  <span class="inline-flex px-1.5 py-0.5 text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded">
                    {{ enrolledByText(e.enrolledByType) }}
                  </span>
                  @if (e.enrolledByUserId) {
                    <span class="text-xs text-gray-400 ml-1">#{{ e.enrolledByUserId }}</span>
                  }
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  {{ e.enrolledAt | date:'dd/MM/yyyy HH:mm' }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  @if (e.completedAt) {
                    {{ e.completedAt | date:'dd/MM/yyyy HH:mm' }}
                  } @else if (e.exitedAt) {
                    {{ e.exitedAt | date:'dd/MM/yyyy HH:mm' }}
                  } @else { — }
                </td>
                <td class="px-4 py-3">
                  @if (e.lastError) {
                    <span class="inline-flex items-center gap-1 text-xs text-red-600" [title]="e.lastError">
                      <svg class="w-3 h-3 shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                      </svg>
                      {{ e.lastError | slice:0:40 }}{{ e.lastError.length > 40 ? '...' : '' }}
                    </span>
                  } @else { <span class="text-gray-300">—</span> }
                </td>
                <!-- Acciones RF-04 -->
                <td class="px-4 py-3">
                  <div class="flex items-center gap-1">
                    @if (e.status === 'ACTIVE') {
                      <button (click)="executeAction(e)"
                              [disabled]="executingActionId === e.id"
                              title="Ejecutar acción actual"
                              class="inline-flex items-center gap-1 px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 transition-colors">
                        @if (executingActionId === e.id) {
                          <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                          </svg>
                        } @else {
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3l14 9-14 9V3z"/>
                          </svg>
                        }
                        Ejecutar
                      </button>
                    }
                    @if (e.status === 'WAITING') {
                      <button (click)="openResumeModal(e)"
                              title="Reanudar espera"
                              class="inline-flex items-center gap-1 px-2 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 transition-colors">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                        </svg>
                        Reanudar
                      </button>
                    }
                    @if (e.status === 'ACTIVE' || e.status === 'WAITING') {
                      <button (click)="continueEnrollment(e)"
                              [disabled]="continuingId === e.id"
                              title="Continuar ejecución"
                              class="inline-flex items-center gap-1 px-2 py-1 text-xs bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50 transition-colors">
                        @if (continuingId === e.id) {
                          <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                          </svg>
                        } @else {
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                          </svg>
                        }
                        Continuar
                      </button>
                    }
                    <button (click)="openEvaluateModal(e)" title="Evaluar condición"
                            class="p-1 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded transition-colors">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </button>
                    @if (isCancelableStatus(e.status)) {
                      <button (click)="openCancelModal(e)" title="Cancelar inscripción"
                              class="p-1 text-gray-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded transition-colors">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                      </button>
                    }
                    <button (click)="openDetailModal(e)" title="Ver detalle"
                            class="p-1 text-gray-400 hover:text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded transition-colors">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                    <button (click)="timelineEnrollmentId = e.id" title="Ver timeline"
                            class="p-1 text-gray-400 hover:text-teal-600 hover:bg-teal-50 dark:hover:bg-teal-900/20 rounded transition-colors">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="px-4 py-3 border-t border-gray-100 dark:border-gray-700 flex flex-wrap items-center justify-between gap-3">
        <span class="text-sm text-gray-500">
          {{ filteredEnrollments.length }} inscripción(es) mostrada(s)
          @if (totalElements > filteredEnrollments.length) { · {{ totalElements }} total }
        </span>

        @if (totalPages > 1) {
          <div class="flex items-center gap-1">
            <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
                    class="px-2.5 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 transition-colors">
              Anterior
            </button>
            @for (page of pages; track page) {
              <button type="button" (click)="goToPage(page)"
                      class="min-w-[2rem] px-2 py-1.5 text-sm rounded-lg transition-colors"
                      [ngClass]="page === currentPage
                        ? 'bg-brand-600 text-white'
                        : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'">
                {{ page + 1 }}
              </button>
            }
            <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage + 1 >= totalPages"
                    class="px-2.5 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 transition-colors">
              Siguiente
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Modal: Resultado de ejecutar acción RF-06 -->
@if (showActionResultModal && actionResult) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Resultado de Acción</h3>
        <button (click)="closeActionResultModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
      </div>

      <!-- Status -->
      <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
           [ngClass]="actionResult.status === 'SUCCESS' ? 'bg-green-50 dark:bg-green-900/20' : actionResult.status === 'SKIPPED' ? 'bg-gray-50 dark:bg-gray-700/40' : 'bg-red-50 dark:bg-red-900/20'">
        <span class="px-2 py-0.5 rounded-full text-xs font-bold"
              [ngClass]="getActionStatusClass(actionResult.status)">
          {{ statusText(actionResult.status) }}
        </span>
        <p class="text-sm text-gray-700 dark:text-gray-300">{{ actionResult.message }}</p>
      </div>

      <!-- Details -->
      <dl class="space-y-2 text-sm mb-4">
        @if (actionResult.actionType) {
          <div class="flex justify-between">
            <dt class="text-xs text-gray-500">Tipo de acción</dt>
            <dd class="text-xs font-medium text-gray-900 dark:text-white" [title]="actionResult.actionType || ''">{{ stepText(null, actionResult.actionType) }}</dd>
          </div>
        }
        @if (actionResult.targetObjectType) {
          <div class="flex justify-between">
            <dt class="text-xs text-gray-500">Objeto resultado</dt>
            <dd class="text-xs font-medium text-gray-900 dark:text-white">
              {{ recordText(actionResult.targetObjectType, actionResult.targetObjectId) }}
            </dd>
          </div>
        }
        @if (actionResult.nextNodeType) {
          <div class="flex items-center gap-2 p-2 bg-blue-50 dark:bg-blue-900/20 rounded text-xs text-blue-700 dark:text-blue-400">
            Siguiente: {{ nodeTypeText(actionResult.nextNodeType) }}
            @if (actionResult.nextNodeType === 'WAIT') {
              — Pendiente RF-05
            } @else if (actionResult.nextNodeType === 'END') {
              — Workflow completado
            }
          </div>
        }
      </dl>

      @if (actionResult.actionType === 'DELETE_RECORD') {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
          ⚠ Acción de eliminación de registro. Verificar que el registro fue eliminado permanentemente.
        </div>
      }

      @if (actionResult.status === 'SKIPPED') {
        <div class="mb-3 p-2 bg-gray-50 border border-gray-200 rounded text-xs text-gray-600">
          La acción fue omitida (SKIPPED). Posibles causas: integración no configurada, consentimiento rechazado, o permisos insuficientes.
        </div>
      }

      <!-- RF-08 specific output cards -->
      @if (actionResult.actionType === 'CREATE_TASK' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-teal-700 dark:text-teal-400">Tarea creada</p>
          @if (actionResult.output['taskId']) {
            <p class="text-teal-600">ID: <span class="font-mono font-medium">{{ actionResult.output['taskId'] }}</span></p>
          }
          @if (actionResult.output['title']) {
            <p class="text-teal-600">Título: {{ actionResult.output['title'] }}</p>
          }
          @if (actionResult.output['assignedTo']) {
            <p class="text-teal-600">Asignado a: {{ actionResult.output['assignedTo'] }}</p>
          }
          @if (actionResult.output['dueDate']) {
            <p class="text-teal-600">Vence: {{ actionResult.output['dueDate'] }}</p>
          }
        </div>
      }
      @if (actionResult.actionType === 'CREATE_NOTE' && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-xs">
          <p class="font-semibold text-blue-700 dark:text-blue-400">Nota registrada en historial / audit log.</p>
        </div>
      }
      @if (actionResult.actionType === 'COMPLETE_TASK' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-green-700 dark:text-green-400">Tarea completada</p>
          @if (actionResult.output['taskId']) {
            <p class="text-green-600">ID: <span class="font-mono font-medium">{{ actionResult.output['taskId'] }}</span></p>
          }
        </div>
      }
      <!-- Acciones de email: a quién llegó realmente el correo -->
      @if (actionResultRecipients) {
        <div class="mb-3">
          <app-workflow-recipient-list [value]="actionResultRecipients" />
        </div>
      }

      <!-- RF-10: SEND_WEBHOOK -->
      @if (actionResult.actionType === 'SEND_WEBHOOK' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-sky-50 dark:bg-sky-900/20 border border-sky-200 dark:border-sky-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-sky-700 dark:text-sky-400">Webhook enviado</p>
          @if (actionResult.output['httpStatus']) {
            <p class="text-sky-600">HTTP Status: <span class="font-mono font-medium">{{ actionResult.output['httpStatus'] }}</span></p>
          }
          @if (actionResult.output['durationMs'] !== undefined) {
            <p class="text-sky-600">Duración: <span class="font-mono">{{ actionResult.output['durationMs'] }}ms</span></p>
          }
          @if (actionResult.output['mapped']) {
            <p class="text-sky-600">Mapeado: <span class="font-mono">{{ actionResult.output['mapped'] | json }}</span></p>
          }
        </div>
      }
      <!-- RF-10: NATIVE_INTEGRATION_ACTION -->
      @if (actionResult.actionType === 'NATIVE_INTEGRATION_ACTION' && actionResult.status === 'SKIPPED') {
        <div class="mb-3 p-2 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded-lg text-xs">
          <p class="text-gray-500 dark:text-gray-400">Integración nativa pendiente — registrada como SKIPPED.</p>
        </div>
      }
      <!-- RF-10: CODE_SNIPPET -->
      @if (actionResult.actionType === 'CODE_SNIPPET' && actionResult.status === 'SKIPPED') {
        <div class="mb-3 p-2 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded-lg text-xs">
          <p class="text-gray-500 dark:text-gray-400">Code Snippet deshabilitado — requiere sandbox seguro. Registrado como SKIPPED.</p>
        </div>
      }

      <!-- RF-09: CHANGE_DEAL_STAGE -->
      @if (actionResult.actionType === 'CHANGE_DEAL_STAGE' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-orange-700 dark:text-orange-400">Negocio actualizado</p>
          @if (actionResult.output['dealId']) {
            <p class="text-orange-600">Deal ID: <span class="font-mono font-medium">{{ actionResult.output['dealId'] }}</span></p>
          }
          @if (actionResult.output['oldStageId'] !== undefined) {
            <p class="text-orange-600">Etapa anterior: <span class="font-mono">{{ actionResult.output['oldStageId'] }}</span></p>
          }
          @if (actionResult.output['newStageId'] !== undefined) {
            <p class="text-orange-600">Etapa nueva: <span class="font-mono font-medium">{{ actionResult.output['newStageId'] }}</span></p>
          }
        </div>
      }
      <!-- RF-09: UPDATE_DEAL_CLOSE_DATE -->
      @if (actionResult.actionType === 'UPDATE_DEAL_CLOSE_DATE' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-blue-700 dark:text-blue-400">Fecha de cierre actualizada</p>
          @if (actionResult.output['oldCloseDate']) {
            <p class="text-blue-600">Fecha anterior: <span class="font-mono">{{ actionResult.output['oldCloseDate'] }}</span></p>
          }
          @if (actionResult.output['newCloseDate']) {
            <p class="text-blue-600">Fecha nueva: <span class="font-mono font-medium">{{ actionResult.output['newCloseDate'] }}</span></p>
          }
        </div>
      }
      <!-- RF-09: CHANGE_PIPELINE -->
      @if (actionResult.actionType === 'CHANGE_PIPELINE' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-indigo-700 dark:text-indigo-400">Pipeline / ciclo actualizado</p>
          @if (actionResult.output['oldPipelineId'] !== undefined) {
            <p class="text-indigo-600">Pipeline anterior: <span class="font-mono">{{ actionResult.output['oldPipelineId'] }}</span></p>
          }
          @if (actionResult.output['newPipelineId'] !== undefined) {
            <p class="text-indigo-600">Pipeline nuevo: <span class="font-mono font-medium">{{ actionResult.output['newPipelineId'] }}</span></p>
          }
          @if (actionResult.output['oldStageId'] !== undefined) {
            <p class="text-indigo-600">Etapa anterior: <span class="font-mono">{{ actionResult.output['oldStageId'] }}</span></p>
          }
          @if (actionResult.output['newStageId'] !== undefined) {
            <p class="text-indigo-600">Etapa nueva: <span class="font-mono">{{ actionResult.output['newStageId'] }}</span></p>
          }
          @if (actionResult.output['compatibilityMode']) {
            <p class="text-amber-600 font-medium">⚠ Modo compatibilidad: pipeline lógico único.</p>
          }
        </div>
      }

      @if (actionResult.actionType === 'SCHEDULE_MEETING' && actionResult.output && actionResult.status === 'SUCCESS') {
        <div class="mb-3 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg text-xs space-y-1">
          <p class="font-semibold text-indigo-700 dark:text-indigo-400">Reunión programada</p>
          @if (actionResult.output['meetingId']) {
            <p class="text-indigo-600">ID: <span class="font-mono font-medium">{{ actionResult.output['meetingId'] }}</span></p>
          }
          <p class="text-indigo-600">Calendario externo:
            <span class="font-medium">{{ actionResult.output['calendarEventStatus'] ?? 'SKIPPED/NOT_REQUESTED' }}</span>
          </p>
        </div>
      }

      @if (actionResult.output && (actionResult.output | json) !== '{}') {
        <div class="mb-3">
          <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Output</p>
          <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-2 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 max-h-32">{{ actionResult.output | json }}</pre>
        </div>
      }

      <div class="flex justify-end">
        <button (click)="closeActionResultModal()" class="px-4 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200">Cerrar</button>
      </div>
    </div>
  </div>
}

<!-- Modal: Reanudar espera -->
@if (showResumeModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-sm mx-4 p-6">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Reanudar Espera</h3>
        <button (click)="closeResumeModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
      </div>

      @if (resumeError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ resumeError }}</div>
      }

      @if (!resumeResult) {
        <div class="mb-4">
          <p class="text-sm text-gray-600 dark:text-gray-400 mb-3">
            Reanudar inscripción <strong>#{{ resumingEnrollment?.id }}</strong> tomando la rama:
          </p>
          <div class="flex flex-wrap gap-2 mb-3">
            @for (key of resumeBranchOptions; track key) {
              <button type="button" (click)="resumeBranchKey = key"
                      [ngClass]="resumeBranchKey === key
                        ? 'px-3 py-1.5 text-sm font-semibold bg-purple-600 text-white rounded-full'
                        : 'px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'">
                {{ branchLabel(key) }}
              </button>
            }
          </div>
          <input type="text" [(ngModel)]="resumeBranchKey"
                 placeholder="O escribe un branchKey personalizado"
                 class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500 font-mono"/>
        </div>
        <div class="flex gap-2 justify-end">
          <button (click)="closeResumeModal()" class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50">Cancelar</button>
          <button (click)="confirmResume()" [disabled]="resumeLoading"
                  class="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50">
            {{ resumeLoading ? 'Reanudando...' : 'Reanudar' }}
          </button>
        </div>
      } @else {
        <div class="space-y-3">
          <div class="p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 rounded-lg">
            <p class="text-sm font-medium text-green-700 dark:text-green-400">Espera reanudada.</p>
            @if (resumeResult.nextNodeType) {
              <p class="text-xs text-green-600 mt-1">
                Siguiente nodo: {{ nodeText(resumeResult.nextNodeId) }}
                <span class="text-green-500">({{ nodeTypeText(resumeResult.nextNodeType) }})</span>
              </p>
            }
            @if (resumeResult.branchKey) {
              <p class="text-xs text-green-600">Rama: {{ branchLabel(resumeResult.branchKey) }}</p>
            }
            @if (resumeResult.message) {
              <p class="text-xs text-green-500 mt-0.5">{{ resumeResult.message }}</p>
            }
          </div>
          <div class="flex justify-end">
            <button (click)="closeResumeModal()" class="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">Cerrar</button>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Modal: Resultado de continuar ejecución -->
@if (showContinueResultModal && continueResult) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg mx-4 p-6 max-h-[80vh] overflow-y-auto">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Resultado de ejecución</h3>
        <button (click)="closeContinueModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
      </div>

      <!-- Status -->
      <div class="flex items-center gap-2 mb-4 p-3 rounded-lg"
           [ngClass]="continueResult.status === 'COMPLETED' ? 'bg-blue-50 dark:bg-blue-900/20' : 'bg-green-50 dark:bg-green-900/20'">
        <svg class="w-5 h-5 shrink-0" [ngClass]="continueResult.status === 'COMPLETED' ? 'text-blue-600' : 'text-green-600'"
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <p class="text-sm font-medium"
           [ngClass]="continueResult.status === 'COMPLETED' ? 'text-blue-700 dark:text-blue-400' : 'text-green-700 dark:text-green-400'">
          {{ getContinueMessage(continueResult) }}
        </p>
      </div>

      <!-- Rama seleccionada -->
      @if (continueResult.branch?.selectedBranchKey) {
        <div class="mb-4 flex items-center gap-2">
          <span class="text-sm text-gray-600 dark:text-gray-400">Rama tomada:</span>
          <span class="px-3 py-1 bg-indigo-100 text-indigo-700 text-sm font-bold rounded-full">
            {{ continueResult.branch!.selectedBranchKey }}
          </span>
        </div>
      }

      <!-- Detalles -->
      <dl class="grid grid-cols-2 gap-3 mb-4 text-sm">
        @if (continueResult.currentNodeType) {
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
            <dt class="text-xs text-gray-500">Nodo actual</dt>
            <dd class="font-medium text-gray-900 dark:text-white" [title]="continueResult.currentNodeType || ''">{{ nodeText(continueResult.currentNodeId) }}</dd>
          </div>
        }
        @if (continueResult.nextNodeType) {
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
            <dt class="text-xs text-gray-500">Siguiente nodo</dt>
            <dd class="font-medium text-gray-900 dark:text-white" [title]="continueResult.nextNodeType || ''">{{ nodeText(continueResult.nextNodeId) }}</dd>
          </div>
        }
        @if (continueResult.status) {
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
            <dt class="text-xs text-gray-500">Estado</dt>
            <dd class="font-medium text-gray-900 dark:text-white">{{ statusText(continueResult.status) }}</dd>
          </div>
        }
        <div class="bg-gray-50 dark:bg-gray-700/40 rounded p-2">
          <dt class="text-xs text-gray-500">Inscripción</dt>
          <dd class="font-medium font-mono text-gray-900 dark:text-white">#{{ continueResult.enrollmentId }}</dd>
        </div>
      </dl>

      <!-- Condiciones evaluadas -->
      @if (continueResult.details?.evaluatedConditions?.length) {
        <h4 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
          Condiciones evaluadas
        </h4>
        <div class="overflow-x-auto mb-4">
          <table class="w-full text-xs border-collapse">
            <thead class="bg-gray-50 dark:bg-gray-700/50">
              <tr>
                <th class="text-left px-2 py-1.5 font-medium text-gray-500 border border-gray-200 dark:border-gray-600">Propiedad</th>
                <th class="text-left px-2 py-1.5 font-medium text-gray-500 border border-gray-200 dark:border-gray-600">Operador</th>
                <th class="text-left px-2 py-1.5 font-medium text-gray-500 border border-gray-200 dark:border-gray-600">Esperado</th>
                <th class="text-left px-2 py-1.5 font-medium text-gray-500 border border-gray-200 dark:border-gray-600">Actual</th>
                <th class="text-left px-2 py-1.5 font-medium text-gray-500 border border-gray-200 dark:border-gray-600">Resultado</th>
              </tr>
            </thead>
            <tbody>
              @for (cond of continueResult.details!.evaluatedConditions; track $index) {
                <tr class="border-b border-gray-100 dark:border-gray-700">
                  <td class="px-2 py-1.5 font-mono border border-gray-200 dark:border-gray-600">{{ cond.property ?? '—' }}</td>
                  <td class="px-2 py-1.5 border border-gray-200 dark:border-gray-600">{{ operatorText(cond.operator) }}</td>
                  <td class="px-2 py-1.5 font-mono border border-gray-200 dark:border-gray-600">{{ cond.expected ?? '—' }}</td>
                  <td class="px-2 py-1.5 font-mono border border-gray-200 dark:border-gray-600">{{ cond.actual ?? '—' }}</td>
                  <td class="px-2 py-1.5 border border-gray-200 dark:border-gray-600">
                    <span [ngClass]="cond.result ? 'text-green-600 font-semibold' : 'text-red-500 font-semibold'">
                      {{ cond.result ? '✓ true' : '✗ false' }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <!-- Resultado de acción (RF-06/RF-07/RF-08) -->
      @if (isActionResult(continueResult)) {
        <div class="mb-4 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
          <div class="flex items-center gap-2 flex-wrap mb-1">
            <span class="text-xs font-semibold text-green-700 dark:text-green-400">Acción ejecutada</span>
            @if (continueResult.details?.['actionType']) {
              <span class="px-1.5 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-700 rounded text-[10px]">
                {{ stepText(null, continueResult.details!['actionType']) }}
              </span>
            }
            @if (continueResult.details?.['actionStatus']) {
              <span class="px-1.5 py-0.5 rounded text-[10px] font-bold"
                    [ngClass]="getActionStatusClass(continueResult.details!['actionStatus'])">
                {{ statusText(continueResult.details!['actionStatus']) }}
              </span>
            }
          </div>
          @if (continueResult.details?.['targetObjectType']) {
            <p class="text-xs text-green-600 dark:text-green-400 mb-1">
              Resultado: {{ recordText(continueResult.details!['targetObjectType'], continueResult.details!['targetObjectId']) }}
            </p>
          }
          <!-- RF-08: CREATE_TASK -->
          @if (continueResult.details?.['actionType'] === 'CREATE_TASK' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-teal-700 dark:text-teal-400">Tarea creada</p>
              @if (continueResult.details!['output']['taskId']) {
                <p class="text-teal-600">ID: <span class="font-mono">{{ continueResult.details!['output']['taskId'] }}</span></p>
              }
              @if (continueResult.details!['output']['title']) {
                <p class="text-teal-600">Título: {{ continueResult.details!['output']['title'] }}</p>
              }
              @if (continueResult.details!['output']['assignedTo']) {
                <p class="text-teal-600">Asignado a: {{ continueResult.details!['output']['assignedTo'] }}</p>
              }
              @if (continueResult.details!['output']['dueDate']) {
                <p class="text-teal-600">Vence: {{ continueResult.details!['output']['dueDate'] }}</p>
              }
            </div>
          }
          <!-- RF-08: CREATE_NOTE -->
          @if (continueResult.details?.['actionType'] === 'CREATE_NOTE' && continueResult.details?.['actionStatus'] === 'SUCCESS') {
            <div class="mt-2 p-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded text-[10px]">
              <p class="font-semibold text-blue-700 dark:text-blue-400">Nota registrada en historial / audit log.</p>
            </div>
          }
          <!-- RF-08: COMPLETE_TASK -->
          @if (continueResult.details?.['actionType'] === 'COMPLETE_TASK' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-green-700 dark:text-green-400">Tarea completada</p>
              @if (continueResult.details!['output']['taskId']) {
                <p class="text-green-600">ID: <span class="font-mono">{{ continueResult.details!['output']['taskId'] }}</span></p>
              }
            </div>
          }
          <!-- RF-10: SEND_WEBHOOK -->
          @if (continueResult.details?.['actionType'] === 'SEND_WEBHOOK' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-sky-50 dark:bg-sky-900/20 border border-sky-200 dark:border-sky-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-sky-700 dark:text-sky-400">Webhook enviado</p>
              @if (continueResult.details!['output']['httpStatus']) {
                <p class="text-sky-600">HTTP: <span class="font-mono font-medium">{{ continueResult.details!['output']['httpStatus'] }}</span></p>
              }
              @if (continueResult.details!['output']['durationMs'] !== undefined) {
                <p class="text-sky-600">Duración: <span class="font-mono">{{ continueResult.details!['output']['durationMs'] }}ms</span></p>
              }
            </div>
          }
          <!-- RF-10: NATIVE_INTEGRATION_ACTION / CODE_SNIPPET SKIPPED -->
          @if ((continueResult.details?.['actionType'] === 'NATIVE_INTEGRATION_ACTION' || continueResult.details?.['actionType'] === 'CODE_SNIPPET') && continueResult.details?.['actionStatus'] === 'SKIPPED') {
            <div class="mt-2 p-2 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded text-[10px]">
              <p class="text-gray-500 dark:text-gray-400">
                {{ continueResult.details!['actionType'] === 'CODE_SNIPPET' ? 'Code Snippet deshabilitado (sandbox pendiente).' : 'Integración nativa pendiente de configuración.' }} — SKIPPED.
              </p>
            </div>
          }
          <!-- RF-09: CHANGE_DEAL_STAGE -->
          @if (continueResult.details?.['actionType'] === 'CHANGE_DEAL_STAGE' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-orange-700 dark:text-orange-400">Negocio actualizado</p>
              @if (continueResult.details!['output']['oldStageId'] !== undefined) {
                <p class="text-orange-600">Etapa anterior: <span class="font-mono">{{ continueResult.details!['output']['oldStageId'] }}</span></p>
              }
              @if (continueResult.details!['output']['newStageId'] !== undefined) {
                <p class="text-orange-600">Etapa nueva: <span class="font-mono font-medium">{{ continueResult.details!['output']['newStageId'] }}</span></p>
              }
            </div>
          }
          <!-- RF-09: UPDATE_DEAL_CLOSE_DATE -->
          @if (continueResult.details?.['actionType'] === 'UPDATE_DEAL_CLOSE_DATE' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-blue-700 dark:text-blue-400">Fecha de cierre actualizada</p>
              @if (continueResult.details!['output']['oldCloseDate']) {
                <p class="text-blue-600">Anterior: <span class="font-mono">{{ continueResult.details!['output']['oldCloseDate'] }}</span></p>
              }
              @if (continueResult.details!['output']['newCloseDate']) {
                <p class="text-blue-600">Nueva: <span class="font-mono font-medium">{{ continueResult.details!['output']['newCloseDate'] }}</span></p>
              }
            </div>
          }
          <!-- RF-09: CHANGE_PIPELINE -->
          @if (continueResult.details?.['actionType'] === 'CHANGE_PIPELINE' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-indigo-700 dark:text-indigo-400">Pipeline / ciclo actualizado</p>
              @if (continueResult.details!['output']['oldPipelineId'] !== undefined) {
                <p class="text-indigo-600">Pipeline anterior: <span class="font-mono">{{ continueResult.details!['output']['oldPipelineId'] }}</span></p>
              }
              @if (continueResult.details!['output']['newPipelineId'] !== undefined) {
                <p class="text-indigo-600">Pipeline nuevo: <span class="font-mono font-medium">{{ continueResult.details!['output']['newPipelineId'] }}</span></p>
              }
              @if (continueResult.details!['output']['compatibilityMode']) {
                <p class="text-amber-600">⚠ Modo compatibilidad.</p>
              }
            </div>
          }
          <!-- RF-08: SCHEDULE_MEETING -->
          @if (continueResult.details?.['actionType'] === 'SCHEDULE_MEETING' && continueResult.details?.['output']) {
            <div class="mt-2 p-2 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded text-[10px] space-y-0.5">
              <p class="font-semibold text-indigo-700 dark:text-indigo-400">Reunión programada</p>
              @if (continueResult.details!['output']['meetingId']) {
                <p class="text-indigo-600">ID: <span class="font-mono">{{ continueResult.details!['output']['meetingId'] }}</span></p>
              }
              <p class="text-indigo-600">Calendario externo:
                <span class="font-medium">{{ continueResult.details!['output']['calendarEventStatus'] ?? 'SKIPPED/NOT_REQUESTED' }}</span>
              </p>
            </div>
          }
          <!-- SKIPPED -->
          @if (continueResult.details?.['actionStatus'] === 'SKIPPED') {
            <p class="text-xs text-gray-500 mt-1">
              {{ continueResult.details!['skipReason'] ?? 'Integración no configurada o consentimiento rechazado.' }}
            </p>
          }
        </div>
      }

      <div class="flex justify-end">
        <button (click)="closeContinueModal()"
                class="px-4 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600">
          Cerrar
        </button>
      </div>
    </div>
  </div>
}

<!-- Modal: Evaluar condición -->
@if (showEvaluateModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6 max-h-[80vh] overflow-y-auto">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Evaluar condición</h3>
        <button (click)="closeEvaluateModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
      </div>

      @if (evaluateError) {
        <div class="mb-3 p-2 bg-red-50 border border-red-200 text-red-600 text-sm rounded">{{ evaluateError }}</div>
      }

      @if (!evaluateResult) {
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Enrollment ID <span class="text-gray-400 font-normal">(auto)</span>
            </label>
            <input type="number" [(ngModel)]="evaluateEnrollmentId"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Node ID del nodo CONDITION <span class="text-red-500">*</span>
            </label>
            <input type="number" [(ngModel)]="evaluateNodeId" placeholder="ID del nodo de condición"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Contexto adicional (JSON) <span class="text-gray-400 font-normal">(opcional)</span>
            </label>
            <textarea [(ngModel)]="evaluateContextJson" rows="4"
                      class="w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
          </div>
          <div class="flex gap-2 justify-end">
            <button (click)="closeEvaluateModal()" class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50">Cancelar</button>
            <button (click)="confirmEvaluate()" [disabled]="evaluateLoading"
                    class="px-4 py-2 text-sm bg-amber-500 text-white rounded-lg hover:bg-amber-600 disabled:opacity-50">
              {{ evaluateLoading ? 'Evaluando...' : 'Evaluar' }}
            </button>
          </div>
        </div>
      } @else {
        <!-- Resultado de evaluación -->
        <div class="mb-3 flex items-center gap-2">
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Resultado:</span>
          <span class="px-2 py-0.5 rounded-full text-xs font-bold"
                [ngClass]="evaluateResult.conditionResult ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
            {{ evaluateResult.conditionResult ? 'true' : 'false' }}
          </span>
          @if (evaluateResult.selectedBranchKey) {
            <span class="text-sm text-gray-600 dark:text-gray-400 ml-2">Rama:</span>
            <span class="px-3 py-0.5 bg-indigo-100 text-indigo-700 text-sm font-bold rounded-full">
              {{ evaluateResult.selectedBranchKey }}
            </span>
          }
        </div>

        @if (evaluateResult.details?.evaluatedConditions?.length) {
          <table class="w-full text-xs border-collapse mb-3">
            <thead class="bg-gray-50 dark:bg-gray-700/50">
              <tr>
                <th class="text-left px-2 py-1 border border-gray-200 dark:border-gray-600">Propiedad</th>
                <th class="text-left px-2 py-1 border border-gray-200 dark:border-gray-600">Op</th>
                <th class="text-left px-2 py-1 border border-gray-200 dark:border-gray-600">Esperado</th>
                <th class="text-left px-2 py-1 border border-gray-200 dark:border-gray-600">Actual</th>
                <th class="text-left px-2 py-1 border border-gray-200 dark:border-gray-600">OK</th>
              </tr>
            </thead>
            <tbody>
              @for (c of evaluateResult.details!.evaluatedConditions; track $index) {
                <tr>
                  <td class="px-2 py-1 font-mono border border-gray-200 dark:border-gray-600">{{ c.property ?? '—' }}</td>
                  <td class="px-2 py-1 border border-gray-200 dark:border-gray-600">{{ operatorText(c.operator) }}</td>
                  <td class="px-2 py-1 font-mono border border-gray-200 dark:border-gray-600">{{ c.expected ?? '—' }}</td>
                  <td class="px-2 py-1 font-mono border border-gray-200 dark:border-gray-600">{{ c.actual ?? '—' }}</td>
                  <td class="px-2 py-1 border border-gray-200 dark:border-gray-600" [ngClass]="c.result ? 'text-green-600' : 'text-red-500'">{{ c.result ? '✓' : '✗' }}</td>
                </tr>
              }
            </tbody>
          </table>
        }

        <div class="flex gap-2 justify-end">
          <button (click)="evaluateResult = null" class="px-3 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50">← Volver</button>
          <button (click)="closeEvaluateModal()" class="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">Cerrar</button>
        </div>
      }
    </div>
  </div>
}

<!-- Modal: Cancelar inscripción -->
@if (showCancelModal && selectedEnrollmentToCancel) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">Cancelar inscripción</h3>
        <button (click)="closeCancelModal()" class="text-gray-400 hover:text-gray-600">&times;</button>
      </div>

      <!-- Advertencia -->
      <div class="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg">
        <p class="text-sm font-medium text-amber-800 dark:text-amber-300">
          ¿Seguro que deseas sacar este registro del workflow?
        </p>
        <p class="text-xs text-amber-700 dark:text-amber-400 mt-1">
          Esta acción cancelará la inscripción activa y detendrá ejecuciones pendientes.
        </p>
      </div>

      <!-- Datos del enrollment -->
      <dl class="grid grid-cols-2 gap-2 mb-4 text-sm">
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Inscripción</dt>
          <dd class="font-mono font-medium text-gray-900 dark:text-white">#{{ selectedEnrollmentToCancel.id }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Estado</dt>
          <dd>
            <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="getStatusClass(selectedEnrollmentToCancel.status)">
              {{ getStatusLabel(selectedEnrollmentToCancel.status) }}
            </span>
          </dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">Tipo</dt>
          <dd class="font-medium text-gray-900 dark:text-white" [title]="selectedEnrollmentToCancel.objectType">{{ objectTypeText(selectedEnrollmentToCancel.objectType) }}</dd>
        </div>
        <div>
          <dt class="text-xs text-gray-500 dark:text-gray-400">ID del registro</dt>
          <dd class="font-mono text-gray-900 dark:text-white">#{{ selectedEnrollmentToCancel.objectId }}</dd>
        </div>
      </dl>

      @if (cancelError) {
        <div class="mb-3 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">{{ cancelError }}</div>
      }

      <!-- Motivo -->
      <div class="mb-5">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Motivo <span class="text-gray-400 font-normal">(opcional)</span>
        </label>
        <textarea [(ngModel)]="cancelReason" rows="3"
                  placeholder="Cancelado manualmente desde la interfaz"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"></textarea>
        <p class="mt-1 text-xs text-gray-400">Si se deja vacío se usará: "Cancelado manualmente desde la interfaz".</p>
      </div>

      <div class="flex gap-2 justify-end">
        <button (click)="closeCancelModal()" [disabled]="isCancelling"
                class="px-4 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 disabled:opacity-50">
          Mantener inscripción
        </button>
        <button (click)="confirmCancelEnrollment()" [disabled]="isCancelling"
                class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-2">
          @if (isCancelling) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Cancelando...
          } @else {
            Cancelar inscripción
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- Modal: Detalle de enrollment -->
@if (showDetailModal && detailEnrollment) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg mx-4 max-h-[85vh] flex flex-col">
      <!-- Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-gray-700 shrink-0">
        <div class="flex items-center gap-3">
          <h3 class="text-base font-semibold text-gray-900 dark:text-white">Inscripción #{{ detailEnrollment.id }}</h3>
          <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium"
                [ngClass]="getStatusClass(detailEnrollment.status)">
            {{ getStatusLabel(detailEnrollment.status) }}
          </span>
        </div>
        <button (click)="closeDetailModal()" class="text-gray-400 hover:text-gray-600 text-xl leading-none">&times;</button>
      </div>

      <!-- Body -->
      <div class="overflow-y-auto p-6 space-y-4">
        <!-- Info principal -->
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Tipo de objeto</dt>
            <dd class="font-medium text-gray-900 dark:text-white" [title]="detailEnrollment.objectType">{{ objectTypeText(detailEnrollment.objectType) }}</dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">ID del registro</dt>
            <dd class="font-mono font-medium text-gray-900 dark:text-white">#{{ detailEnrollment.objectId }}</dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Workflow</dt>
            <dd class="text-gray-900 dark:text-white">{{ workflow?.name || ('#' + detailEnrollment.workflowId) }}</dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Nodo actual</dt>
            <dd class="text-gray-900 dark:text-white" [title]="detailEnrollment.currentNodeId ? ('nodo #' + detailEnrollment.currentNodeId) : ''">{{ nodeText(detailEnrollment.currentNodeId) }}</dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Inscrito por</dt>
            <dd class="text-gray-900 dark:text-white">
              {{ enrolledByText(detailEnrollment.enrolledByType) }}
              @if (detailEnrollment.enrolledByUserId) { <span class="text-gray-400 text-xs ml-1">(usuario #{{ detailEnrollment.enrolledByUserId }})</span> }
            </dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3">
            <dt class="text-xs text-gray-500 dark:text-gray-400 mb-0.5">Fuente</dt>
            <dd class="text-gray-900 dark:text-white">{{ enrollmentSourceText(detailEnrollment.enrollmentSource) }}</dd>
          </div>
        </div>

        <!-- Fechas -->
        <div>
          <h4 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Fechas</h4>
          <div class="space-y-1.5 text-sm">
            <div class="flex justify-between">
              <span class="text-gray-500 dark:text-gray-400">Inscrito el</span>
              <span class="font-medium text-gray-900 dark:text-white">{{ detailEnrollment.enrolledAt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
            </div>
            @if (detailEnrollment.completedAt) {
              <div class="flex justify-between">
                <span class="text-gray-500 dark:text-gray-400">Completado el</span>
                <span class="font-medium text-blue-700 dark:text-blue-400">{{ detailEnrollment.completedAt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
              </div>
            }
            @if (detailEnrollment.exitedAt) {
              <div class="flex justify-between">
                <span class="text-gray-500 dark:text-gray-400">Salida el</span>
                <span class="font-medium text-gray-700 dark:text-gray-300">{{ detailEnrollment.exitedAt | date:'dd/MM/yyyy HH:mm:ss' }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Motivo de salida/cancelación -->
        @if (detailEnrollment.exitReason || detailEnrollment.exitMessage) {
          <div class="p-3 rounded-lg border"
               [ngClass]="detailEnrollment.status === 'CANCELLED' ? 'bg-gray-50 dark:bg-gray-700/40 border-gray-200 dark:border-gray-600' : 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800'">
            <h4 class="text-xs font-semibold mb-1"
                [ngClass]="detailEnrollment.status === 'CANCELLED' ? 'text-gray-600 dark:text-gray-400' : 'text-amber-700 dark:text-amber-400'">
              {{ detailEnrollment.status === 'CANCELLED' ? 'Motivo de cancelación' : 'Motivo de salida' }}
            </h4>
            @if (detailEnrollment.exitReason) {
              <p class="text-sm text-gray-800 dark:text-gray-200 font-medium">{{ exitReasonText(detailEnrollment.exitReason) }}</p>
            }
            @if (detailEnrollment.exitMessage) {
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ detailEnrollment.exitMessage }}</p>
            }
          </div>
        }

        <!-- Último error -->
        @if (detailEnrollment.lastError) {
          <div class="p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <h4 class="text-xs font-semibold text-red-700 dark:text-red-400 mb-1">Último error</h4>
            <p class="text-xs font-mono text-red-600 dark:text-red-300 break-all">{{ detailEnrollment.lastError }}</p>
          </div>
        }

        <!-- Contexto -->
        @if (detailEnrollment.context && getEnrollmentContextKeys(detailEnrollment.context).length > 0) {
          <div>
            <h4 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Contexto</h4>
            <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg border border-gray-200 dark:border-gray-600 overflow-x-auto text-gray-800 dark:text-gray-200 max-h-32">{{ detailEnrollment.context | json }}</pre>
          </div>
        }

        <!-- Historial de pasos -->
        <div class="p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-dashed border-gray-300 dark:border-gray-600 text-center">
          <p class="text-xs text-gray-400 dark:text-gray-500">
            El historial detallado de pasos aún no está disponible en esta vista.
          </p>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-between px-6 py-4 border-t border-gray-100 dark:border-gray-700 shrink-0">
        @if (isCancelableStatus(detailEnrollment.status)) {
          <button (click)="openCancelFromDetail()"
                  class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
            Cancelar inscripción
          </button>
        } @else {
          <span></span>
        }
        <button (click)="closeDetailModal()"
                class="px-4 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
          Cerrar
        </button>
      </div>
    </div>
  </div>
}

<!-- Modal: Inscripción manual -->
@if (showEnrollModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Inscribir manualmente</h3>

      @if (enrollError) {
        <div class="mb-3 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">{{ enrollError }}</div>
      }

      <form [formGroup]="enrollForm" (ngSubmit)="confirmEnroll()" novalidate>
        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tipo de objeto <span class="text-red-500">*</span>
            </label>
            <select formControlName="objectType"
                    [class]="'w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ' + (isFieldInvalid('objectType') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')">
              @for (opt of objectTypeOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Registro <span class="text-red-500">*</span>
            </label>
            @if (isSearchableType()) {
              <app-entity-select
                [value]="enrollForm.value.objectId"
                (valueChange)="enrollForm.patchValue({ objectId: $event })"
                (selected)="onRecordSelected($event)"
                [displayText]="recordDisplayText"
                [searchFn]="recordSearch" [labelFn]="recordLabel" [sublabelFn]="recordSublabel"
                placeholder="Buscar por nombre…"></app-entity-select>
            } @else {
              <input type="number" formControlName="objectId" placeholder="Ej: 42"
                     [class]="'w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ' + (isFieldInvalid('objectId') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')"/>
              <p class="mt-1 text-xs text-gray-400">Este tipo de objeto aún no tiene buscador por nombre; ingresa el ID.</p>
            }
            @if (isFieldInvalid('objectId')) {
              <p class="mt-1 text-xs text-red-500">Selecciona un registro.</p>
            }
          </div>
          <div class="p-2.5 bg-gray-50 dark:bg-gray-700/40 rounded-lg border border-gray-100 dark:border-gray-600">
            <p class="text-xs text-gray-500 dark:text-gray-400">Workflow</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white break-words">{{ workflow?.name ?? '—' }}</p>
            @if (workflow?.publishedVersionId) {
              <p class="text-xs text-green-600 dark:text-green-400 mt-0.5">Versión publicada #{{ workflow!.publishedVersionId }}</p>
            } @else {
              <p class="text-xs text-amber-600 dark:text-amber-400 mt-0.5">
                Sin versión publicada — publica el workflow en el constructor para poder inscribir registros.
              </p>
            }
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Motivo <span class="text-gray-400 font-normal">(opcional)</span>
            </label>
            <input type="text" formControlName="reason" placeholder="Ej: Prueba manual RF-03"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
        </div>
        <div class="flex gap-2 mt-5 justify-end">
          <button type="button" (click)="closeEnrollModal()"
                  class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700">
            Cancelar
          </button>
          <button type="submit" [disabled]="enrollLoading"
                  class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {{ enrollLoading ? 'Inscribiendo...' : 'Inscribir' }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

<!-- Timeline RF-14 -->
@if (timelineEnrollmentId) {
  <app-workflow-timeline-modal
    [enrollmentId]="timelineEnrollmentId"
    (closed)="timelineEnrollmentId = null">
  </app-workflow-timeline-modal>
}
